import { useEffect, useState } from "react";

export default function useRotatingSlogan(items, delay = 5000) {
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(true);

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % items.length);
            }, 300);

            setTimeout(() => setFade(false), 600);
        }, delay);

        return () => clearInterval(interval);
    }, [items, delay]);

    return { item: items[index], fade };
}
